import { Injectable } from "@angular/core";
import { RestClientService } from "src/app/core/services/rest/rest-client.service";
import { NatureGarantie } from "../model/garanties/nature-garantie";
import { NatureGarantieDocument } from "../model/garanties/NatureGarantieDocument";
import { NatureGarantieChamp } from "../model/garanties/NatureGarantieChamp";

@Injectable({
  providedIn: "root",
})
export class NatureGarantieService {
  constructor(private _restClientService: RestClientService) {}

  getAllNatureWithGarantieChamps() {
    return this._restClientService.load<NatureGarantie[]>(
      "natures-garanties/list-with-garantie-champs"
    );
  }

  getListNatureGarantie() {
    return this._restClientService.load<NatureGarantie[]>(
      "natures-garanties/list"
    );
  }

  getNatureGarantieById(natureGarantieId) {
    return this._restClientService.load<NatureGarantie>(
      "natures-garanties/get/" + natureGarantieId
    );
  }

  add(natureGarantie) {
    return this._restClientService.save<NatureGarantie>(
      "natures-garanties/add",
      natureGarantie
    );
  }

  update(natureGarantieId: number, natureGarantie) {
    return this._restClientService.put<NatureGarantie>(
      `natures-garanties/update/${natureGarantieId}`,
      natureGarantie
    );
  }

  delete(natureGarantieId: number) {
    return this._restClientService.delete<NatureGarantie>(
      `natures-garanties/delete/${natureGarantieId}`
    );
  }

  // Nature Document garanties
  getNatureGarantieDocuments(natureGarantieId: number) {
    return this._restClientService.load<NatureGarantieDocument[]>(
      "natures-garanties/documents/nature-garantie-id/" + natureGarantieId
    );
  }

  addNatureGarantieDocument(data: NatureGarantieDocument, natureGarantieId: number) {
    return this._restClientService.save<NatureGarantie>(
      `natures-garanties/add-document-to-nature-garantie/${natureGarantieId}`,
      data
    );
  }

  deleteNatureGarantieDocument(natureGarantieDocumentId: number) {
    return this._restClientService.delete<any>(
      `natures-garanties/delete-document-to-nature-garantie/${natureGarantieDocumentId}`);
  }

  // Nature Champs garanties
  getNatureGarantieChamps(natureGarantieId: number) {
    return this._restClientService.load<NatureGarantieChamp[]>(
      "natures-garanties/champs/nature-garantie-id/" + natureGarantieId
    );
  }

  associerChamps(
    natureGarantieId: number,
    associerChamps: NatureGarantieChamp[]
  ) {
    return this._restClientService.save<NatureGarantie>(
      `natures-garanties/associer-champs/${natureGarantieId}`,
      associerChamps
    );
  }
}
